'use client';
import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import { CURRENCY, SITE } from '@/app/constants';
import type { PaidTrialInfo } from '@/app/types';
import { cn, formatAmount } from '@/app/utils';

const PAID_TRIAL_BANNER_BG =
  SITE === 'china'
    ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/paid-trial-banner-bg-4005a6c0.webp'
    : 'https://image01.cf.vidu.studio/vidu/media-asset/paid-trial-banner-bg-4005a6c0.webp';

/**
 * 付费试用横幅：与 DiscountBanner 同位置展示，两者同时存在时由 SubscriptionBanner 轮播。
 * 文案为「新用户专享 / N 天 VIP 会员低至 ¥X」，数字与价格用高亮色强调。
 */
export const PaidTrialBanner: FC<{ paidTrial: PaidTrialInfo; className?: string }> = ({ paidTrial, className }) => {
  const t = useTranslations();

  return (
    <div
      className={cn(
        'relative flex h-[120px] w-full flex-col items-center justify-center gap-1.5 overflow-hidden rounded-16 bg-center bg-cover bg-no-repeat px-3 sm:h-[100px] sm:gap-1',
        className,
      )}
      style={{ backgroundImage: `url(${PAID_TRIAL_BANNER_BG})` }}
    >
      <div className="text-center font-semibold text-2xl text-white sm:text-base">
        {t('payments.plans.trialBannerTitle')}
      </div>
      <div className="flex flex-wrap items-center justify-center gap-x-2.5 text-center font-semibold text-[28px] leading-[1.4] sm:text-lg">
        <span className="text-[#B4A5FF]">{paidTrial.duration_days}</span>
        <span className="text-white">{t('payments.plans.trialBannerDuration')}</span>
        <span className="text-[#B4A5FF]">
          <span className="text-white">{CURRENCY}</span>
          {formatAmount(paidTrial.price)}
        </span>
      </div>
    </div>
  );
};
